import { render, staticRenderFns } from "./_user_external_vr.form.vue?vue&type=template&id=2f666802&scoped=true&"
import script from "./_user_external_vr.form.vue?vue&type=script&lang=js&"
export * from "./_user_external_vr.form.vue?vue&type=script&lang=js&"
import style0 from "./_user_external_vr.form.vue?vue&type=style&index=0&id=2f666802&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f666802",
  null
  
)

export default component.exports